<section class="legal">
  <header class="legal__head">
    <h1>Legal Notice</h1>
    <p class="legal__sub">
      Information according to § 5 TMG (German Telemedia Act)
    </p>
  </header>

  <div class="legal__card">
    <h2>Provider</h2>
    <p>
      <strong>noHEROES GmbH</strong><br />
      Myllendonker Straße 284<br />
      41065 Mönchengladbach<br />
      Germany
    </p>

    <h2>Contact</h2>
    <p>
      Email: <a href="mailto:support@noheroestcg.de">support&#64;noheroestcg.de</a>
    </p>

    <h2>Management</h2>
    <p>
      Managing Director(s): <span class="placeholder">Can Demir</span>
    </p>

    <h2>Commercial Register</h2>
    <p>
      Registered in the commercial register.<br />
      Register court: <span class="placeholder">Amtsgerichts Dortmund</span><br />
      Registration number: <span class="placeholder">HRB 35985</span>
    </p>

    <h2>VAT Identification Number</h2>
    <p>
      VAT ID according to § 27a UStG: <strong>DE367961777</strong>
    </p>

    <h2>Responsible for content</h2>
    <p>
      noHEROES GmbH, address as stated above.
    </p>
  </div>

  <div class="legal__note">
    <p class="muted">
      This legal notice is provided for informational purposes and does not constitute legal advice.
    </p>
  </div>
</section>
